import React from "react";
import { Button } from "antd";
import { FilterOutlined, CloseOutlined, DownloadOutlined } from "@ant-design/icons";
import styles from "./DashBoardCard.module.css";

const CardActions = ({ widget, isSuccess, removeWidget, exportToPNG, showFilters }) => {
    if (widget.gridData.without_header) {
        return <>
            <div style={{ display: "flex", justifyContent: "end", flexDirection: "row-reverse", columnGap: "5px", width: `30%` }}>
                <Button
                    style={{
                        position: "inherit",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onMouseDown={e => e.stopPropagation()}
                    onClick={(e) => {
                        removeWidget(e);
                    }}
                    icon={
                        <CloseOutlined />
                    }
                    // type="link"
                    data-testid="closeWidget"
                >
                </Button>
                {widget?.gridData?.showFilter && isSuccess && (
                    <div style={{ display: "flex", columnGap: "5px" }}>
                        <Button
                            style={{
                                position: "inherit",
                                border: "none",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                            onMouseDown={e => e.stopPropagation()}
                            className={styles.filtersBtn}
                            icon={<FilterOutlined />}
                            onClick={showFilters}
                            data-testid="openFilters"
                        ></Button>
                        <Button
                            style={{
                                position: "inherit",
                                border: "none",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                            onMouseDown={e =>
                                e.stopPropagation()}
                            onClick={exportToPNG}
                            icon={<DownloadOutlined />}>
                        </Button>
                    </div>

                )}

            </div>
        </>;
    }
    return (
        <div style={{ display: "flex", justifyContent: "end", flexDirection: "row-reverse", columnGap: "5px", width: `30%` }}>
            <div style={{ display: "flex", justifyContent: "end" }}>
                <Button
                    style={{
                        position: "inherit",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onMouseDown={e => e.stopPropagation()}
                    onClick={(e) => {
                        removeWidget(e);
                    }}
                    icon={
                        <CloseOutlined />
                    }
                    // type="link"
                    data-testid="closeWidget"
                >
                </Button>
            </div>

            <div style={{ display: "flex", columnGap: "5px" }}>
                {widget?.gridData?.showFilter && isSuccess && (
                    <Button
                        style={{
                            position: "inherit",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onMouseDown={e => e.stopPropagation()}
                        className={styles.filtersBtn}
                        icon={<FilterOutlined />}
                        onClick={showFilters}
                        data-testid="openFilters"
                    ></Button>
                )}
                <Button
                    style={{
                        position: "inherit",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onMouseDown={e =>
                        e.stopPropagation()}
                    onClick={exportToPNG}
                    icon={<DownloadOutlined />}>
                </Button>
            </div>
        </div>
    );
};

export default CardActions;